<template>
  <div class="settings">
    <div class="content">
      <div class="wrapper">
        <div class="main-wrap">

          <div class="settings-header">
            Item Categories
            <div class="settings-header__btn">
              <el-button type="success" size="mini" @click="routerLink('settings-dashboard')">Settings Dashboard</el-button>
            </div>
          </div>

          <div class="nav-tree">
            <el-select v-model="categoriesGroupId" placeholder="Categories Group" size="mini" filterable @change="loadList()" style="margin-right: 20px;">
              <el-option v-for="item in categoriesGroupList"
                :key="item.id"
                :label="item.name"
                :value="item.id">
              </el-option>
            </el-select>

            <el-button :disabled="!categoriesGroupId" @click="openModalAdd" class="nav-tree__item" size="mini" type="primary" plain icon="el-icon-plus">Add Item</el-button>
          </div>

          <el-table
            max-height="720"
            :data="tableData"
            :empty-text="$t('general_noData')"
            row-key="id"
            default-expand-all
            style="width: 100%">
            <el-table-column
              type="index"
              label="ID"
              width="80">
            </el-table-column>
            <el-table-column
              prop="code"
              label="Code"
              width="140">
            </el-table-column>
            <el-table-column
              prop="name"
              label="Name">
            </el-table-column>
            <el-table-column
              :label="$t('settings_eType_createdOn')"
              align="center"
              width="150">
              <template slot-scope="scope">
                {{moment(scope.row.createdAtMil, 'x').format('D MMM YY')}}
              </template>
            </el-table-column>
            <el-table-column
              width="150"
              :label="$t('settings_eType_operations')">
              <template slot-scope="scope">
                <el-button
                  v-if="!scope.row.parentId"
                  size="mini"
                  type="success"
                  plain
                  icon="el-icon-plus"
                  @click="handleAddSubItem(scope.row)">Add Sub Item</el-button>
              </template>
            </el-table-column>
            <el-table-column
              width="120"
              label="">
              <template slot-scope="scope">
                <el-button
                  size="mini"
                  type="primary"
                  plain
                  icon="el-icon-edit"
                  @click="scope.row.parentId ? handleEditSubItem(scope.row) : handleEditItem(scope.row)"></el-button>
                <el-button
                  size="mini"
                  type="danger"
                  plain
                  icon="el-icon-delete"
                  @click="handleDeleteItem(scope.row)"></el-button>
              </template>
            </el-table-column>
          </el-table>

        </div>
      </div>
    </div>

    <!-- add Item -->
    <sweet-modal blocking title="Add Item" ref="openModal" class="modal" v-on:close="closeModal">

      <el-form :model="form" ref="form" status-icon :rules="rules" label-width="0" class="demo-ruleForm">
        <el-form-item prop="code">
          <el-input label="Code" v-model.trim="form.code" maxlength="10" show-word-limit></el-input>
        </el-form-item>
        <el-form-item prop="name">
          <el-input label="Name" v-model="form.name" maxlength="100" show-word-limit></el-input>
        </el-form-item>

        <el-form-item class="modal__btn">
          <el-button @click="modalCancel('openModal')">{{$t('general_cancel')}}</el-button>
          <el-button @click="addItem('form')" type="primary">{{$t('general_submit')}}</el-button>
        </el-form-item>
      </el-form>

    </sweet-modal>

    <!-- add Sub Item -->
    <sweet-modal blocking title="Add Sub Item" ref="openModalAddSubItem" class="modal" v-on:close="closeModal">

      <el-form :model="formAddSubItem" ref="formAddSubItem" status-icon :rules="rules" label-width="0" class="demo-ruleForm">
        <el-form-item prop="code">
          <el-input label="Code" v-model.trim="formAddSubItem.code" maxlength="10" show-word-limit></el-input>
        </el-form-item>
        <el-form-item prop="name">
          <el-input label="Name" v-model="formAddSubItem.name" maxlength="100" show-word-limit></el-input>
        </el-form-item>

        <el-form-item class="modal__btn">
          <el-button @click="modalCancel('openModalAddSubItem')">{{$t('general_cancel')}}</el-button>
          <el-button @click="addSubItem('formAddSubItem')" type="primary">{{$t('general_submit')}}</el-button>
        </el-form-item>
      </el-form>

    </sweet-modal>

    <!-- edit Item -->
    <sweet-modal blocking title="Edit Item" ref="openModalEdit" class="modal" v-on:close="closeModal">

      <el-form :model="formEdit" ref="formEdit" status-icon :rules="rules" label-width="0" class="demo-ruleForm">
        <el-form-item prop="code">
          <el-input label="Code" v-model.trim="formEdit.code" maxlength="10" show-word-limit></el-input>
        </el-form-item>
        <el-form-item prop="name">
          <el-input label="Name" v-model="formEdit.name" maxlength="100" show-word-limit></el-input>
        </el-form-item>

        <el-form-item class="modal__btn">
          <el-button @click="modalCancel('openModalEdit')">{{$t('general_cancel')}}</el-button>
          <el-button @click="editItem('formEdit')" type="primary">{{$t('general_submit')}}</el-button>
        </el-form-item>
      </el-form>

    </sweet-modal>

    <!-- edit Sub Item -->
    <sweet-modal blocking title="Edit Sub Item" ref="openModalEditSubItem" class="modal" v-on:close="closeModal">

      <el-form :model="formEditSubItem" ref="formEditSubItem" status-icon :rules="rules" label-width="0" class="demo-ruleForm">
        <el-form-item prop="code">
          <el-input label="Code" v-model.trim="formEditSubItem.code" maxlength="10" show-word-limit></el-input>
        </el-form-item>
        <el-form-item prop="name">
          <el-input label="Name" v-model="formEditSubItem.name" maxlength="100" show-word-limit></el-input>
        </el-form-item>

        <el-form-item class="modal__btn">
          <el-button @click="modalCancel('openModalEditSubItem')">{{$t('general_cancel')}}</el-button>
          <el-button @click="editSubItem('formEditSubItem')" type="primary">{{$t('general_submit')}}</el-button>
        </el-form-item>
      </el-form>

    </sweet-modal>

  </div>
</template>

<script>
  let moment = require('moment')
  import axios from 'axios'
  import { SweetModal } from '@totalflow4/tfsweet-modal-vue'

  export default {
    components: {
      SweetModal,
    },
    async mounted () {
      await this.getCategoriesGroup()
      await this.loadList()
    },
    computed: {
      companyLayout() {
        return this.$store.getters.getCompanyLayout
      },
    },
    data() {
      return {
        moment: moment,

        categoriesGroupList: null,
        categoriesGroupId: null,
        tableData: [],
        selectedRowId: '',
        form: {
          code: '',
          name: ''
        },
        formEdit: {
          code: '',
          name: ''
        },
        formAddSubItem: {
          code: '',
          name: ''
        },
        formEditSubItem: {
          code: '',
          name: ''
        },
        rules: {
          code: [
            { required: true, message: this.$i18n.t('modal_settings_fieldIsRequired'), trigger: 'blur' }
          ],
          name: [
            { required: true, message: this.$i18n.t('modal_settings_fieldIsRequired'), trigger: 'blur' }
          ]
        },
      }
    },
    methods: {
      routerLink(page) {
        this.$router.push({name: page, query: { companyId: this.$route.query.companyId}} )
      },
      async getCategoriesGroup() {
        let loader = this.$loading.show();
        try {
          axios.defaults.headers.common['Authorization'] = 'Bearer ' + sessionStorage.getItem('token');
          axios.defaults.headers.common['X-Timezone-Offset'] = ((new Date()).getTimezoneOffset() / 60).toString();
          const { data } = await axios.get(`/api/v1/itemCategoryGroup/list?companyId=${this.$route.query.companyId}`)
          this.categoriesGroupList = data.list
        } catch (error) {
          console.log('An error occurred:', error)
        } finally {
          loader.hide()
        }
      },
      async loadList() {
        let loader = this.$loading.show();
        try {
          axios.defaults.headers.common['Authorization'] = 'Bearer ' + sessionStorage.getItem('token');
          axios.defaults.headers.common['X-Timezone-Offset'] = ((new Date()).getTimezoneOffset() / 60).toString();
          const { data } = await axios.get(`/api/v1/item/category/list?companyId=${this.$route.query.companyId}&groupId=${this.categoriesGroupId}`)
          this.tableData = data.list
        } catch (error) {
          console.log('An error occurred:', error)
        } finally {
          loader.hide()
        }
      },
      addItem(form) {
        this.$refs[form].validate(async (valid) => {
          if (valid) {
            let loader = this.$loading.show();
            try {
              axios.defaults.headers.common['Authorization'] = 'Bearer ' + sessionStorage.getItem('token');
              axios.defaults.headers.common['X-Timezone-Offset'] = ((new Date()).getTimezoneOffset() / 60).toString();
              await axios.post(`/api/v1/item/category/create?companyId=${this.$route.query.companyId}`, {
                ...this.form,
                parentId: null,
                groupId: this.categoriesGroupId })
              await this.loadList()
              this.$refs.openModal.close()
            } catch (error) {
              console.log('An error occurred:', error)
            } finally {
              loader.hide()
            }
          } else {
            console.log('error submit!')
            return false
          }
        });
      },
      async handleEditItem(row) {
        this.selectedRowId = row.id

        let loader = this.$loading.show()
        try {
          axios.defaults.headers.common['Authorization'] = 'Bearer ' + sessionStorage.getItem('token');
          axios.defaults.headers.common['X-Timezone-Offset'] = ((new Date()).getTimezoneOffset() / 60).toString();
          const { data } = await axios.get(`/api/v1/item/category/item?companyId=${this.$route.query.companyId}&id=${row.id}`)
          this.formEdit.code = data.inventory.code
          this.formEdit.name = data.inventory.name
          this.$refs.openModalEdit.open()
        } catch (error) {
          console.log('An error occurred:', error)
        } finally {
          loader.hide()
        }
      },
      editItem(form) {
        this.$refs[form].validate(async (valid) => {
          if (valid) {
            let loader = this.$loading.show()
            try {
              axios.defaults.headers.common['Authorization'] = 'Bearer ' + sessionStorage.getItem('token');
              axios.defaults.headers.common['X-Timezone-Offset'] = ((new Date()).getTimezoneOffset() / 60).toString();
              await axios.post(`/api/v1/item/category/update?companyId=${this.$route.query.companyId}&id=${this.selectedRowId}`, this.formEdit)
              await this.loadList()
              this.$refs.openModalEdit.close()
            } catch (error) {
              console.log('An error occurred:', error)
            } finally {
              loader.hide()
            }
          } else {
            console.log('error submit!')
            return false
          }
        });
      },
      handleDeleteItem(row) {
        this.selectedRowId = row.id

        this.$confirm(row.isUsed ? this.$t('general_deleteTitleResetToDefault') : this.$t('general_deleteTitle'), this.$t('settings_regions_warning'), {
          confirmButtonText: this.$t('general_ok'),
          cancelButtonText: this.$t('general_cancel'),
          type: 'info'
        }).then(async () => {

          let loader = this.$loading.show()
          try {
            axios.defaults.headers.common['Authorization'] = 'Bearer ' + sessionStorage.getItem('token');
            axios.defaults.headers.common['X-Timezone-Offset'] = ((new Date()).getTimezoneOffset() / 60).toString();
            await axios.delete(`/api/v1/item/category/delete?companyId=${this.$route.query.companyId}&id=${this.selectedRowId}`)
            this.$message({ type: 'success', message: this.$t('general_deleteCompleted') })
            await this.loadList()
          } catch (error) {
            console.log('An error occurred:', error)
          } finally {
            loader.hide()
          }
        }).catch(() => {
          this.$message({ type: 'info', message: this.$t('general_deleteCanceled') })
        })
      },
      handleAddSubItem(row) {
        this.selectedRowId = row.id
        this.$refs.openModalAddSubItem.open()
      },
      addSubItem(form) {
        this.$refs[form].validate(async (valid) => {
          if (valid) {
            let loader = this.$loading.show()
            try {
              axios.defaults.headers.common['Authorization'] = 'Bearer ' + sessionStorage.getItem('token');
              axios.defaults.headers.common['X-Timezone-Offset'] = ((new Date()).getTimezoneOffset() / 60).toString();
              await axios.post(`/api/v1/item/category/create?companyId=${this.$route.query.companyId}`, {
                ...this.formAddSubItem,
                parentId: this.selectedRowId,
                groupId: this.categoriesGroupId })
                this.$refs.openModalAddSubItem.close()
                await this.loadList()
            } catch (error) {
              console.log('An error occurred:', error)
            } finally {
              loader.hide()
            }
          } else {
            console.log('error submit!')
            return false
          }
        })
      },
      async handleEditSubItem(row) {
        this.selectedRowId = row.id

        let loader = this.$loading.show()
        try {
          axios.defaults.headers.common['Authorization'] = 'Bearer ' + sessionStorage.getItem('token');
          axios.defaults.headers.common['X-Timezone-Offset'] = ((new Date()).getTimezoneOffset() / 60).toString();
          const { data } = await axios.get(`/api/v1/item/category/item?companyId=${this.$route.query.companyId}&id=${row.id}`)
          this.formEditSubItem.code = data.inventory.code
          this.formEditSubItem.name = data.inventory.name
          this.$refs.openModalEditSubItem.open()
        } catch (error) {
          console.log('An error occurred:', error)
        } finally {
          loader.hide()
        }
      },
      editSubItem(form) {
        this.$refs[form].validate(async (valid) => {
          if (valid) {
            let loader = this.$loading.show()
            try {
              axios.defaults.headers.common['Authorization'] = 'Bearer ' + sessionStorage.getItem('token');
              axios.defaults.headers.common['X-Timezone-Offset'] = ((new Date()).getTimezoneOffset() / 60).toString();
              await axios.post(`/api/v1/item/category/update?companyId=${this.$route.query.companyId}&id=${this.selectedRowId}`, this.formEditSubItem)
              await this.loadList()
              this.$refs.openModalEditSubItem.close()
            } catch (error) {
              console.log('An error occurred:', error)
            } finally {
              loader.hide()
            }
          } else {
            console.log('error submit!')
            return false
          }
        })
      },
      // handleDeleteSubItem(row) {
      //   this.selectedRowId = row.id

      //   this.$confirm(row.isUsed ? this.$t('general_deleteTitleResetToDefault') : this.$t('general_deleteTitle'), this.$t('settings_regions_warning'), {
      //     confirmButtonText: this.$t('general_ok'),
      //     cancelButtonText: this.$t('general_cancel'),
      //     type: 'info'
      //   }).then(() => {
      //     this.$message({
      //       type: 'success',
      //       message: this.$t('general_deleteCompleted')
      //     });

      //     let loader = this.$loading.show();
      //     axios.defaults.headers.common['Authorization'] = 'Bearer ' + sessionStorage.getItem('token');
      //     axios.defaults.headers.common['X-Timezone-Offset'] = ((new Date()).getTimezoneOffset() / 60).toString();
      //     axios
      //       .post(`/api/v1/settings/company-stage/delete?stageId=${this.selectedRowId}`)
      //       .then(response => {
      //         this.loadList()
      //         loader.hide()
      //       })
      //       .catch(error => {
      //         console.log('An error occurred:', error);
      //         loader.hide()
      //       });
      //   }).catch(() => {
      //     this.$message({
      //       type: 'info',
      //       message: this.$t('general_deleteCanceled')
      //     });
      //   });
      // },
      openModalAdd(){
        this.$refs.openModal.open()
      },
      closeModal(){
        this.$refs['form'].resetFields()
        this.$refs['formAddSubItem'].resetFields()
        this.$refs['formEdit'].resetFields()
        this.$refs['formEditSubItem'].resetFields()
      },
      modalCancel(ref) {
        this.$refs[ref].close();
      },
    },
  }
</script>

<style lang="scss" scoped>
.settings {
  background: #DfE8F0;
}
.content {
  display: flex;
  min-height: 100vh;
  padding-top: 50px;
  .wrapper{
    background: #fff;
    margin: 10px;
    width: 100%;
    display: flex;
    justify-content: center;
    .main-wrap {
      padding: 20px;
      width: 100%;
      // max-width: 1500px;
    }
    &.animation{
      margin-left: 260px;
      transition: margin-left 500ms ease-out, transform 500ms ease-out;
    }
  }
}
</style>
